import React, { useState, useCallback, useMemo, useContext } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { renderContentFromMetadata } from '@jutro/uiconfig';
// import appConfig from 'app-config';
// import { EntryPageTemplate } from 'gw-components-platform-react';
import { Loader } from '@jutro/components';
import { useAuthentication } from 'gw-digital-auth-react';
import EntryPageTemplate from '../../customer/components/EntryPageTemplate/EntryPageTemplate';

import metadata from './EntryPage.metadata.json5';
import styles from './EntryPage.module.scss';
import './EntryPage.messages';
import messages from '../LandingPage/LandingPage.messages';
import { Link } from 'gw-components-platform-react';
import { TranslatorContext } from '@jutro/locale';

const VIEWS = {
    logInView: 'LOG_IN_VIEW',
    signUpView: 'SIGN_UP_VIEW',
    forgotPasswordView: 'FORGOT_PASSWORD_VIEW'
};

function EntryPage({ location }) {
    const { isAuthInProgress } = useAuthentication();
    const [view, updateView] = useState(VIEWS.logInView);
    const { state } = location;
    const [showSignup, updateShowSignup] = useState(true);
    const translator = useContext(TranslatorContext);

    const handleForgotPasswordClick = useCallback(() => {
        updateView(VIEWS.forgotPasswordView);
    }, []);

    const handleSignUpClick = useCallback(() => {
        updateView(VIEWS.signUpView);
    }, []);

    const handleSignInClick = useCallback(() => {
        updateView(VIEWS.logInView);
    }, []);

    const handleShowSignup = useCallback(() => {
        updateShowSignup(false);
    }, []);

    const phoneToTrigger = (event, agentPhone) => {
        event.preventDefault();
        window.location = `tel:${agentPhone}`;
    };

    const mailToTrigger = useCallback((event, email) => {
        event.preventDefault();
        window.location = `mailto:${email}`;
    }, []);

    const getNeedHelpLink = useMemo(() => {
        return (
            <span>
                {translator(messages.needHelpText)}
                {' '}
                <Link className={styles.hyperlink} onClick={(e) => phoneToTrigger(e, '833-481-5976')} href="/">
                    1-800-265-8813
                </Link>
				&nbsp; Ext. 9020&nbsp;or email at&nbsp;
                <Link className={styles.hyperlink} onClick={(e) => mailToTrigger(e, 'optimsupport@heartlandfarmmutual.com')} href="/">
                    optimsupport@hfmi.ca
                </Link>
            </span>

        );
    }, [translator]);

    if (isAuthInProgress) {
        return <Loader loaded={!isAuthInProgress} />;
    }

    const overrideProps = {
        gwLoginComponent: {
            successPath: _.get(state, 'from.pathname') || '/home'
        },
        logInViewContainer: {
            visible: view === VIEWS.logInView
        },
        signUpViewContainer: {
            visible: view === VIEWS.signUpView
        },
        forgotPasswordViewContainer: {
            visible: view === VIEWS.forgotPasswordView
        },
        signUpLinkContainer: {
            visible: showSignup
        },
        needHelpSection: {
            content: getNeedHelpLink,
        },
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onForgotPasswordClick: handleForgotPasswordClick,
            onSignUpClick: handleSignUpClick,
            onSignInClick: handleSignInClick,
            onHandleShowSignupClick: handleShowSignup
        }
    };

    const renderedContentFromMetadata = renderContentFromMetadata(
        metadata.pageContent,
        overrideProps,
        resolvers
    );

    return (
        <EntryPageTemplate
            contentToRender={renderedContentFromMetadata}
        />
    );
}

EntryPage.propTypes = {
    location: PropTypes.shape({
        state: PropTypes.shape({})
    })
};

EntryPage.defaultProps = {
    location: {}
};

export default EntryPage;
